import { render, staticRenderFns } from "./UnitsOption.vue?vue&type=template&id=7b64f8c7&"
import script from "./UnitsOption.vue?vue&type=script&lang=js&"
export * from "./UnitsOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports